import { combineReducers } from "redux"
import { B2bBlocks } from "./homeBlocksReducer";


const authReducers = combineReducers({
    B2bBlocks
})

export default authReducers
